import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { DropPlaceholderComponent, customViewSortingOrGroupingPaneDragHandleStyle, DragHandle, sortingPaneDragPreviewComponent, sortingPaneRenderItem, DropPlaceholderComponentForGroupingAndSortingPane } from "csi/middleware/customView/data/dnd/data-management-tab-components";
import DragPreviewLayer from "designSystem/dnd/components/DragPreviewLayer";
import { DndMode, DndStore, DndStoreContext, DragAndColumnDropWrapper } from "designSystem/dnd/index";
import { useSyncLocalStore } from "designSystem/hooks";
import { Button, GridRow, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { DND_TYPE, SortingLevel, useCustomViewSortingStore } from "./CustomViewSortingStore";

const customViewSortingPaneDropTypes = [DND_TYPE.SORTING_LEVEL];

const CustomViewSortingPane: FunctionComponent = observer(() => {
	const {
		addSortingLevel,
		dropItem,
		overLimit,
		sortingList,
	} = useCustomViewSortingStore();

	const dndStore = useSyncLocalStore(() => new DndStore<SortingLevel>());
	const { dragItem } = dndStore;

	return (
		<Accordion data-csi-automation="CustomViewSortingPane">
			<AccordionSummary>
				<Text res="CustomViewSortingPane" semiBold />
			</AccordionSummary>
			<AccordionDetails>
				<DndStoreContext.Provider value={dndStore}>
					<DragAndColumnDropWrapper<SortingLevel>
						canDrag
						data-csi-automation="CustomViewSortingLevel"
						disableBgColorChangeOnDrag
						dragHandle={DragHandle}
						dragHandleStyle={customViewSortingOrGroupingPaneDragHandleStyle}
						dragType={DND_TYPE.SORTING_LEVEL}
						dropPlaceholder={DropPlaceholderComponentForGroupingAndSortingPane}
						dropTypes={customViewSortingPaneDropTypes}
						isFullScreen
						isRootDropWrapper
						list={sortingList}
						mode={DndMode.Normal}
						onDrop={dropItem}
						renderItem={sortingPaneRenderItem}
					/>
					{dragItem instanceof SortingLevel && <DragPreviewLayer previewComponent={sortingPaneDragPreviewComponent} />}
				</DndStoreContext.Provider>
				<GridRow 
					data-csi-automation="CustomViewSortingButtons"
					spacingAroundY={1}
				>
					<Button
						design="outline"
						disabled={overLimit}
						onClick={addSortingLevel}
						res="CustomViewAddSortLevel"
					/>
				</GridRow>
			</AccordionDetails>
		</Accordion>
	);
});

export default CustomViewSortingPane;
